module.exports = __webpack_public_path__ + "img/filler_3_mob.63b5606e.svg";